import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import moment from "moment";
import VueMq from "vue-mq";
import LoadScript from 'vue-plugin-load-script';

import {
  BootstrapVue,
  BootstrapVueIcons
} from "bootstrap-vue";
import "@/assets/scss/custom.scss";

import {
  library
} from '@fortawesome/fontawesome-svg-core';
import {
  fas
} from '@fortawesome/free-solid-svg-icons'
import {
  fab
} from '@fortawesome/free-brands-svg-icons';
import {
  far
} from '@fortawesome/free-regular-svg-icons';
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome';

library.add(fas, fab, far);

Vue.component('font-awesome-icon', FontAwesomeIcon);

moment.locale("en");

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

Vue.use(VueMq, {
  breakpoints: {
    sp: 770,
    pc: 771,
  },
  defaultBreakpoint: "pc",
});

Vue.use(LoadScript);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");